import { Link } from "react-router-dom";

interface PaziaBreadcrumbsProps {
  segments: {
    title: string;
    path?: string;
  }[];
  className?: string;
}

export const PaziaBreadcrumbs = ({ segments, className }: PaziaBreadcrumbsProps) => {
  return (
    <ul className={`inline-flex flex-wrap text-sm font-medium ${className ?? ""}`}>
      {segments.map((seg) => (
        <li
          className="after:px-2 after:text-slate-400 after:content-['/'] last:after:hidden dark:after:text-slate-600"
          key={seg.title}
        >
          {seg.path ? (
            <Link
              className="hover:text-primary-500 dark:hover:text-primary-500 cursor-pointer text-slate-500 dark:text-slate-400"
              to={seg.path}
            >
              {seg.title}
            </Link>
          ) : (
            <span className="text-primary-500 dark:text-slate-200">{seg.title}</span>
          )}
        </li>
      ))}
    </ul>
  );
};
